'use es6';

const origin = `${window.location.protocol}//${window.location.hostname}`;
export default origin;